import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper } from '@material-ui/core';
import FileBase from 'react-file-base64';
import useStyles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { createPost, updatePost } from '../../actions/posts';
import { useHistory } from 'react-router-dom';

const Form = ({ currentId, setCurrentId }) => {
	const [postData, setPostData] = useState({
		title: '', 
		message: '', 
		tags: '', 
		selectedFile: ''
	});

	const post = useSelector((state) => currentId ? state.posts.posts.find((p) => p._id === currentId) : null);
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = JSON.parse(localStorage.getItem('profile'));
	const history = useHistory();

  const clear = () => {
    setCurrentId(0);
    setPostData({ title: '', message: '', tags: [], selectedFile: '' });
  };

	useEffect(() => {
		// if (!post?.title) clear();
		if(post) setPostData(post);
	}, [post])


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (currentId === 0) {
      dispatch(createPost({ ...postData, name: user?.result?.name }, history));
      clear();
    } else {
      dispatch(updatePost(currentId, { ...postData, name: user?.result?.name }));
      clear();
    }
  };

	if (!user?.result?.name) {
		return (
			<Paper className={classes.paper}>
				<Typography variant='h6' align='center'>
					Please Sign In to create your own posts.
				</Typography>
			</Paper>
		)
	}

	return (
		<Paper className= {classes.paper} elevation={6}>
			<form autoComplete='off' noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
				<Typography variat='h6'>{currentId ? 'Editing' : 'Creating'} a Post</Typography>
				<TextField 
					name='title' 
					variant='outlined' 
					label='Title' 
					fullWidth
					value={postData.title}
					onChange={(e) => setPostData({ ...postData, title: e.target.value })}
				/>
				<TextField 
					name='message' 
					variant='outlined' 
					label='Message' 
					fullWidth
					multiline
					rows={4}
					value={postData.message}
					onChange={(e) => setPostData({ ...postData, message: e.target.value })}
				/>
				<TextField 
					name='tags' 
					variant='outlined' 
					label='Tags' 
					fullWidth
					value={postData.tags}
					onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })}
				/>
				<div className={classes.fileInput}>
					<FileBase
						type='file'
						multiple={false}
						onDone={({base64}) => setPostData({ ...postData, selectedFile: base64 })}
						/>
				</div>
				<Button className={classes.buttonSubmit} 
				variant='contained' 
				color='primary' 
				size='large' 
				type='submit'
				fullWidth>submit</Button>
				<Button
				variant='contained' 
				color='secondary' 
				size='small' 
				onClick={clear}
				fullWidth>clear</Button>
			</form>
		</Paper>
	);
}

export default Form;